import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        skill: '<'
    },
    template: `
        <div class="person01">
            <div class="txt">
                <div class="heading01">
                    <h1>{{ vm.skill.name }}</h1>
                    <ul class="actions01">
                        <li><a class="btn edit" ng-click="vm.editSkill(vm.skill)">{{ 'user.Edit data' | translate }}</a></li>
                        <li><a class="btn discrete" ui-sref="employees.competences.skills.list()">{{ 'user.Back to listing' | translate }}</a></li>
                    </ul>
                </div>
                <div class="colholder">
                    <div class="col col01" ng-if="vm.skill.parentSkill">
                        <dl>
                            <dt>{{ 'user.Parent skill' | translate }}</dt>
                            <dd>{{ vm.skill.parentSkill.name }}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <div class="well">
            <div class="heading01">
                <h2>{{ 'user.Subskills' | translate }}</h2>
                <a class="btn add" ng-click="vm.addSkill(vm.skill)">{{ 'user.Add skill subskill' | translate }}</a>
            </div>
            <list-factory-empty list="vm.subSkillList" show-add-message="true"></list-factory-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.subSkillList.items.length">
                <thead>
                <tr>
                    <th>{{ 'user.Skills' | translate }}</th>
                    <th>{{ 'user.Levels' | translate }}</th>
                    <th>{{ 'user.Competences' | translate }}</th>
                    <th>{{ 'user.Roles' | translate }}</th>
                    <th>{{ 'user.Employees' | translate }}</th>
                    <th class="actions">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat-start="item in vm.subSkillList.items">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: item.id })">{{ item.name }}</td>
                    <td></td>
                    <td>{{ item.competenceCount }}</td>
                    <td></td>
                    <td>{{ item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteCategory(item.id)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l2item in item.children" class="level02">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l2item.id })">{{ l2item.name }}</td>
                    <td></td>
                    <td>{{ l2item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l2item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l2item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteCategory(l2item.id)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l3item in l2item.children" class="level03">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l3item.id })">{{ l3item.name }}</td>
                    <td></td>
                    <td>{{ l3item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l3item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l3item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteCategory(l3item.id)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l4item in l3item.children" class="level04">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l4item.id })">{{ l4item.name }}</td>
                    <td></td>
                    <td>{{ l4item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l4item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l4item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteCategory(l4item.id)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                </tbody>
            </table>
        </div>
        <div class="well color02">
            <div class="heading01">
                <h2>{{ 'user.Associated employees' | translate }}</h2>
            </div>
            <list-factory-empty list="vm.employeeList" show-add-message="true"></list-factory-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.employeeList.items.length">
                <thead>
                <tr>
                    <th>{{ 'user.Name' | translate }}</th>
                    <th>{{ 'user.Skill level' | translate }}</th>
                    <th>{{ 'user.Comment' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="userSkill in vm.employeeList.items">
                        <td>{{ userSkill.user.displayName }}</td>
                        <td>{{ userSkill.level }}</td>
                        <td>{{ userSkill.comment }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.employeeList"></pagination>
        </div>
        <div class="well color03">
            <div class="heading01">
                <h2>{{ 'user.Associated competences' | translate }}</h2>
            </div>
            <list-factory-empty list="vm.skillList" show-add-message="true"></list-factory-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.skillList.items.length">
                <thead>
                <tr>
                    <th>{{ 'user.Name' | translate }}</th>
                    <th>{{ 'user.Skill type in competence' | translate }}</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                        <tr ng-repeat="skillCompetence in vm.skillList.items">
                            <td>{{ skillCompetence.competency.name }}</td>
                            <td>{{ vm.USER_COMPETENCE_SKILL_TYPE_ENUM.LABELS[skillCompetence.type] }}</td>
                            <td class="actions">
                                <a ui-sref="authorized.user.competence.competence.view({ id: skillCompetence.competencyId })" class="btn edit">{{ 'general.Edit' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
            </table>
            <pagination list="vm.skillList"></pagination>
        </div>
        <ul class="actions01">
            <li class="primary"><button class="btn negative" ng-click="vm.deleteSkill()">{{ 'user.Delete skill' | translate }}</button></li>
            <li><a class="btn discrete">{{ 'general.Back' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor ($translate, $state, ModalService, ListFactory, SkillResource, UserSkillResource, DATATABLES, USER_COMPETENCE_SKILL_TYPE_ENUM) {
        this.DATATABLES = DATATABLES;
        this.$translate = $translate;
        this.$state = $state;
        this.ModalService = ModalService;
        this.SkillResource = SkillResource;
        this.UserSkillResource = UserSkillResource;
        this.ListFactory = ListFactory;
        this.USER_COMPETENCE_SKILL_TYPE_ENUM = USER_COMPETENCE_SKILL_TYPE_ENUM;
    }

    $onInit () {
        this.subSkillList = this.ListFactory.createWithPagination(this.SkillResource.tree.bind(this.SkillResource));
        this.subSkillList.fetch({ id: this.skill.id });

        this.skillList = this.ListFactory.createWithPagination(this.SkillResource.competenceSkills.bind(this.SkillResource));
        this.skillList.fetch({ skillId: this.skill.id, expand: 'competency' });

        this.employeeList = this.ListFactory.createWithPagination(this.UserSkillResource.query.bind(this.UserSkillResource));
        this.employeeList.fetch({ skillId: this.skill.id, expand: 'skill,user' });
    }

    deleteSkill () {
        const deleteMessage = this.$translate.instant('Do you want to delete skill?');
        this.ModalService.confirm(deleteMessage, 'medium')
            .then(() =>
                this.SkillResource.delete({ id: this.skill.id }).$promise
                    .then(() => this.$state.go('authorized.user.competence.skill.list'))
            )
        ;
    }

    addSkill (skill) {
        return this.ModalService.open({
            template: `<modals-competence-skill-add-sub on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(subSkill)" parent-skill="vm.skill" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.skill = skill;
                this.update = (subSkill) => {
                    this.$uibModalInstance.close(subSkill);
                };
            }
        }).then((subSkill) => {
            this.subSkillList.items.push(subSkill);
        });
    }

    editSkill (skill) {
        return this.ModalService.open({
            template: `<modals-competence-skill-edit on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(updatedSkill)" skill="vm.skill" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.skill = skill;
                this.update = (updatedSkill) => {
                    this.$uibModalInstance.close(updatedSkill);
                };
            }
        }).then((updatedSkill) => {
            this.skill = updatedSkill;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/skill/view/index.js